export const RECURRING_SERVICE = 'recurring';
export const ONCALL_SERVICE = 'oncall';
export const PROCESSED_SERVICE = 'processed';
export const HAULER_REPORTED_ISSUE = 'Hauler Reported Issue';
export const HAULER_ACCEPTED = 'Hauler Accepted';
export const PENDING_HAULER_ACCEPT = 'Pending Hauler Accept';
export const PROCESSED = 'Processed';
export const LIMIT_PER_PAGE = 15;
